import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconArrowLeft = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.2932 6.62615C11.6837 6.23562 12.3169 6.23562 12.7074 6.62615C13.098 7.01667 13.098 7.64983 12.7074 8.04036L9.74787 10.9999H16.667C17.2193 10.9999 17.667 11.4476 17.667 11.9999C17.667 12.5522 17.2193 12.9999 16.667 12.9999H9.74787L12.7074 15.9595C13.098 16.35 13.098 16.9832 12.7074 17.3737C12.3169 17.7642 11.6837 17.7642 11.2932 17.3737L6.62655 12.707C6.23603 12.3165 6.23603 11.6833 6.62655 11.2928L11.2932 6.62615Z"
        />
      </svg>
    );
  }
);
